import { defineComponent as _defineComponent } from 'vue'
import { MasterAccountInfo } from 'ctp-user-auth-service';
import './styles/master-component.scss';
import { onMounted, computed } from 'vue';
import useStore from '@/utils/store/common';


export default /*#__PURE__*/_defineComponent({
  __name: 'MasterComponent',
  setup(__props) {

const store = useStore();
const getSelectedMasterAccount = computed(() => store.getters['user/getSelectedMasterAccount']);
const getMasterAccounts = computed(() => store.getters['user/getMasterAccounts']);

onMounted(async () => {
  await store.dispatch('user/listMasterAccounts');
  await store.dispatch('tollDomain/fetchVariants');
});

function selectMaster(account: MasterAccountInfo) {
  store.dispatch('user/setMasterAccount', account);
}

return { __sfc: true,store, getSelectedMasterAccount, getMasterAccounts, selectMaster }
}

})